// Source-line candidates for the invoice workflow editor, built from an
// already-loaded supplier order (existing supplierOrdersApi query owner).
// Options carry business labels (order number + product + remaining
// quantity); IDs travel as values only.
import {
  getSupplierOrderDisplayNumber,
  type SupplierOrderDto,
} from '../../dto/supplierOrder';
import { normalizeUnitCode } from '../../utils/units';
import type { WorkflowInvoiceSourceLineCandidate } from '../../types/workflowInvoice';
import { sourceQuantitySetFromLine } from './workflowInvoiceQuantity';

function toDimensionalUnit(unit: unknown): WorkflowInvoiceSourceLineCandidate['remainingUnit'] {
  const collapsed = typeof unit === 'string' ? normalizeUnitCode(unit) : null;
  return collapsed === 'pcs' || collapsed === 'm2' || collapsed === 'm3' ? collapsed : null;
}

export function buildPurchaseSourceLineCandidates(
  order: SupplierOrderDto,
): WorkflowInvoiceSourceLineCandidate[] {
  const orderNumber = getSupplierOrderDisplayNumber(order);
  return (order.items || []).map((item) => ({
    sourceOrderLineId: item.id,
    sourceOrderId: order.id,
    orderNumber,
    productName: item.name,
    productVariantId: item.productVariantId ?? null,
    variantLabel: null,
    remainingQuantity: item.pzReceipt?.remainingQuantity ?? null,
    remainingUnit: toDimensionalUnit(item.unit),
    width: item.width ?? null,
    height: item.height ?? null,
    length: item.length ?? null,
    thickness: item.thickness ?? null,
    sourceQuantitySet: sourceQuantitySetFromLine(item),
  }));
}
